import React from 'react';
import { Link } from 'react-router-dom';

function StarMethodGuide({ darkMode }) {
  const cardClass = darkMode 
    ? 'bg-gray-800 text-white' 
    : 'bg-white text-gray-800';

  return (
    <div className="min-h-screen py-8 px-4 bg-gradient-to-br from-pink-50 via-purple-50 to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="max-w-4xl mx-auto">
        {/* 헤더 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-pink-600 to-indigo-600 bg-clip-text text-transparent">
            면접관이 좋아하는 답변 패턴
          </h1>
          <p className="text-2xl font-bold mb-2 text-purple-600">STAR 기법</p>
          <p className={`text-xl ${darkMode ? 'text-gray-300' : 'text-gray-600'} leading-relaxed`}>
            경험 질문에 완벽하게 대답하는 마법의 공식! ✨
          </p>
        </div>

        {/* STAR 기법이 뭔가요? */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🌟</span>
            STAR 기법이 뭔가요?
          </h2>
          
          <p className="text-lg mb-6 leading-relaxed">
            경험을 물어보는 질문에 <strong>구체적이고 설득력 있게</strong> 답변하는 최고의 방법이에요!
          </p>

          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'} border-l-4 border-blue-500`}>
              <h3 className="text-xl font-bold mb-3 text-blue-600">S - Situation (상황)</h3>
              <p className="text-sm leading-relaxed">언제, 어디서 일어난 일인지 간단히 설명해요</p>
              <p className="text-xs mt-2 text-blue-500 font-semibold">⏰ 5초</p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'} border-l-4 border-green-500`}>
              <h3 className="text-xl font-bold mb-3 text-green-600">T - Task (과제)</h3>
              <p className="text-sm leading-relaxed">내가 해야 했던 일이나 목표를 설명해요</p>
              <p className="text-xs mt-2 text-green-500 font-semibold">⏰ 5초</p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'} border-l-4 border-purple-500`}>
              <h3 className="text-xl font-bold mb-3 text-purple-600">A - Action (행동)</h3>
              <p className="text-sm leading-relaxed">내가 실제로 한 행동을 구체적으로 설명해요</p>
              <p className="text-xs mt-2 text-purple-500 font-semibold">⏰ 25초 (가장 중요!)</p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-orange-900 bg-opacity-30' : 'bg-orange-50'} border-l-4 border-orange-500`}>
              <h3 className="text-xl font-bold mb-3 text-orange-600">R - Result (결과)</h3>
              <p className="text-sm leading-relaxed">어떤 결과가 나왔는지 설명해요</p>
              <p className="text-xs mt-2 text-orange-500 font-semibold">⏰ 5초</p>
            </div>
          </div>
        </div>

        {/* 왜 STAR 기법을 써야 할까? */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">💡</span>
            왜 STAR 기법을 써야 할까요?
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-yellow-900 bg-opacity-30' : 'bg-yellow-50'}`}>
              <h3 className="font-bold mb-3 text-yellow-600">👨‍💼 면접관이 가장 선호</h3>
              <p className="text-sm leading-relaxed">
                전 세계 면접관들이 가장 좋아하는 답변 구조예요. 듣기 편하고 이해하기 쉬워서 좋은 인상을 줍니다!
              </p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">🎯 구체적이고 설득력 있음</h3>
              <p className="text-sm leading-relaxed">
                추상적인 설명이 아니라 실제 경험을 바탕으로 한 구체적인 이야기라서 진정성이 느껴져요.
              </p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'}`}>
              <h3 className="font-bold mb-3 text-blue-600">📚 경험 질문에 완벽 대응</h3>
              <p className="text-sm leading-relaxed">
                "~한 경험이 있나요?" 같은 질문에 당황하지 않고 체계적으로 답변할 수 있어요.
              </p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'}`}>
              <h3 className="font-bold mb-3 text-purple-600">🏗️ 논리적이고 체계적</h3>
              <p className="text-sm leading-relaxed">
                순서대로 차근차근 설명하니까 논리적 사고 능력을 보여줄 수 있어요.
              </p>
            </div>
          </div>
        </div>

        {/* 완벽한 STAR 답변 예시 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🎭</span>
            완벽한 STAR 답변 예시 (총 40초)
          </h2>
          
          <div className="mb-6">
            <div className={`p-4 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-100'} border-l-4 border-pink-500`}>
              <h3 className="font-bold text-pink-600 mb-2">📝 질문</h3>
              <p className="text-lg">"팀 프로젝트에서 어려움을 극복한 경험이 있나요?"</p>
            </div>
          </div>

          <div className="space-y-6">
            {/* S - Situation */}
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-20' : 'bg-blue-50'} border-l-4 border-blue-500`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">S</div>
                <span className="font-bold text-blue-600">Situation (상황) - 5초</span>
              </div>
              <p className="text-lg font-semibold">
                "네, 대학교 4학년 때 6명으로 구성된 앱 개발 프로젝트에서 어려움을 극복한 경험이 있습니다."
              </p>
            </div>

            {/* T - Task */}
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-20' : 'bg-green-50'} border-l-4 border-green-500`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">T</div>
                <span className="font-bold text-green-600">Task (과제) - 5초</span>
              </div>
              <p className="text-lg font-semibold">
                "프로젝트 리더로서 일정 관리와 팀 조율을 맡았는데, 6명 중 2명이 개인사정으로 프로젝트 참여가 어려워졌고 시간이 부족한 상황에서 이를 해결해야 했습니다."
              </p>
            </div>

            {/* A - Action */}
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-20' : 'bg-purple-50'} border-l-4 border-purple-500`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">A</div>
                <span className="font-bold text-purple-600">Action (행동) - 25초 ⭐ 가장 중요!</span>
              </div>
              <p className="text-lg font-semibold">
                "저는 먼저 남은 4명의 강점을 파악해서 업무를 재분배했습니다. 그리고 매일 30분씩 진행상황을 공유하는 미팅을 만들어 소통을 강화했고, 다들 부담스러워하는 발표 부분은 제가 직접 맡아서 팀원들이 개발에만 집중할 수 있도록 했습니다."
              </p>
            </div>

            {/* R - Result */}
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-orange-900 bg-opacity-20' : 'bg-orange-50'} border-l-4 border-orange-500`}>
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">R</div>
                <span className="font-bold text-orange-600">Result (결과) - 5초</span>
              </div>
              <p className="text-lg font-semibold">
                "그 결과 예정된 일정보다 3일 빨리 프로젝트를 완성했고, 교수님께 최우수 프로젝트로 선정되었습니다."
              </p>
            </div>
          </div>
        </div>

        {/* 질문 유형별 STAR 적용법 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🎯</span>
            질문 유형별 STAR 적용법
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'}`}>
              <h3 className="font-bold mb-3 text-blue-600">👑 리더십 질문</h3>
              <p className="text-sm mb-2">"리더십을 발휘한 경험은?"</p>
              <p className="text-xs">💡 <strong>Action에서 팀을 이끈 구체적 방법 강조!</strong></p>
              <p className="text-xs mt-1">"팀원들과 개별 면담을 진행해서...", "역할을 재배치하고..."</p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">🧩 문제해결 질문</h3>
              <p className="text-sm mb-2">"어려운 문제를 해결한 경험은?"</p>
              <p className="text-xs">💡 <strong>Action에서 창의적 해결책 부각!</strong></p>
              <p className="text-xs mt-1">"다른 방법을 시도해봤는데...", "새로운 접근법으로..."</p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'}`}>
              <h3 className="font-bold mb-3 text-purple-600">🤝 협업 질문</h3>
              <p className="text-sm mb-2">"팀워크를 발휘한 경험은?"</p>
              <p className="text-xs">💡 <strong>Action에서 소통과 조율 과정 설명!</strong></p>
              <p className="text-xs mt-1">"의견을 조율하기 위해...", "서로 도우면서..."</p>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-orange-900 bg-opacity-30' : 'bg-orange-50'}`}>
              <h3 className="font-bold mb-3 text-orange-600">📈 성장 질문</h3>
              <p className="text-sm mb-2">"실패를 통해 성장한 경험은?"</p>
              <p className="text-xs">💡 <strong>Result에서 배운 점과 성장 포인트 언급!</strong></p>
              <p className="text-xs mt-1">"이를 통해 배운 것은...", "앞으로는 이렇게..."</p>
            </div>
          </div>
        </div>

        {/* Action 부분 강화 팁 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">💪</span>
            Action 부분 강화 팁 (가장 중요!)
          </h2>
          
          <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'} border-l-4 border-purple-500 mb-6`}>
            <h3 className="text-lg font-bold mb-3 text-purple-600">왜 Action이 가장 중요할까요?</h3>
            <p className="leading-relaxed">
              면접관이 가장 궁금해하는 건 <strong>"이 사람이 실제로 어떻게 행동하는지"</strong>예요. 
              상황이나 결과보다는 <strong>여러분의 행동 방식</strong>을 통해 일하는 스타일과 역량을 판단하거든요!
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">✅ 이렇게 하세요!</h3>
              <ul className="space-y-2 text-sm">
                <li>• <strong>"저는 ~했습니다"</strong> 주어를 명확히</li>
                <li>• <strong>구체적인 방법과 과정</strong> 단계별 설명</li>
                <li>• <strong>숫자나 구체적 데이터</strong> 포함하기</li>
                <li>• <strong>"먼저 ~하고, 그 다음 ~했습니다"</strong> 순서대로</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'}`}>
              <h3 className="font-bold mb-3 text-red-600">❌ 이건 피하세요!</h3>
              <ul className="space-y-2 text-sm">
                <li>• <strong>"우리가 했습니다"</strong> → 내 역할이 불분명</li>
                <li>• <strong>"열심히 했습니다"</strong> → 너무 추상적</li>
                <li>• <strong>"잘 해결했습니다"</strong> → 방법이 없음</li>
                <li>• <strong>"그냥 했습니다"</strong> → 계획성 없어 보임</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 피해야 할 실수들 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🚫</span>
            피해야 할 실수들
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-red-900 bg-opacity-30' : 'bg-red-50'} border border-red-200`}>
              <h3 className="font-bold mb-4 text-red-600">❌ 자주 하는 실수들</h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <strong>상황 설명에 너무 많은 시간</strong>
                  <p className="text-xs mt-1">배경 설명을 5분씩 하지 마세요! 간단하게 5초면 충분해요.</p>
                </li>
                <li>
                  <strong>"우리가 했습니다" vs "제가 했습니다"</strong>
                  <p className="text-xs mt-1">팀 활동이어도 내 역할을 명확히 구분해서 말하세요.</p>
                </li>
                <li>
                  <strong>결과 없는 이야기</strong>
                  <p className="text-xs mt-1">행동만 하고 결과가 없으면 의미가 없어요.</p>
                </li>
                <li>
                  <strong>너무 뻔한 결과</strong>
                  <p className="text-xs mt-1">"A+을 받았습니다"만 말고 더 구체적인 성과를!</p>
                </li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'} border border-green-200`}>
              <h3 className="font-bold mb-4 text-green-600">✅ 성공하는 STAR 답변</h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <strong>간결한 상황 설명</strong>
                  <p className="text-xs mt-1">"언제, 어디서, 무엇을" 딱 필요한 정보만!</p>
                </li>
                <li>
                  <strong>명확한 역할 구분</strong>
                  <p className="text-xs mt-1">"팀에서 제가 맡은 역할은..."으로 시작하세요.</p>
                </li>
                <li>
                  <strong>구체적이고 창의적인 행동</strong>
                  <p className="text-xs mt-1">남들과 다른 특별한 방법이나 접근법을 보여주세요.</p>
                </li>
                <li>
                  <strong>의미 있는 결과</strong>
                  <p className="text-xs mt-1">성과뿐만 아니라 배운 점, 성장한 점도 포함하세요.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 실전 연습법 */}
        <div className={`${cardClass} rounded-2xl shadow-2xl p-8 mb-8`}>
          <h2 className="text-2xl font-bold mb-6 flex items-center">
            <span className="text-3xl mr-3">🎯</span>
            실전 연습법
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className={`p-6 rounded-xl ${darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'}`}>
              <h3 className="font-bold mb-3 text-blue-600">📝 미리 준비하기</h3>
              <p className="text-sm leading-relaxed mb-3">
                경험 3-5개를 STAR 형식으로 미리 정리해두세요. 각각 다른 상황으로 준비하면 어떤 질문이 나와도 대응 가능해요!
              </p>
              <ul className="text-xs space-y-1">
                <li>• 리더십 경험 1개</li>
                <li>• 문제해결 경험 1개</li>
                <li>• 협업 경험 1개</li>
                <li>• 실패/성장 경험 1개</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'}`}>
              <h3 className="font-bold mb-3 text-green-600">⏰ 시간 맞춰 연습</h3>
              <p className="text-sm leading-relaxed mb-3">
                각각 40초에 맞춰서 연습하세요. 특히 Action 부분에 25초를 투자해서 구체적으로 말하는 연습이 중요해요!
              </p>
              <ul className="text-xs space-y-1">
                <li>• S: 5초 (간단한 상황)</li>
                <li>• T: 5초 (내 역할)</li>
                <li>• A: 25초 (구체적 행동)</li>
                <li>• R: 5초 (결과와 의미)</li>
              </ul>
            </div>

            <div className={`p-6 rounded-xl ${darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'}`}>
              <h3 className="font-bold mb-3 text-purple-600">🎬 실전 시뮬레이션</h3>
              <p className="text-sm leading-relaxed mb-3">
                친구나 거울 앞에서 실제 면접처럼 연습해보세요. 자연스럽게 말하는 연습이 중요해요!
              </p>
              <ul className="text-xs space-y-1">
                <li>• 휴대폰 녹음해서 들어보기</li>
                <li>• 친구에게 피드백 받기</li>
                <li>• 손짓, 표정도 함께 연습</li>
                <li>• 자신감 있는 목소리 톤</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 뒤로가기 */}
        <div className="text-center">
          <Link 
            to="/guide-success" 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-pink-500 to-indigo-500 hover:from-pink-600 hover:to-indigo-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          >
            <span className="mr-2">←</span>
            면접성공가이드로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  );
}

export default StarMethodGuide;